import { Spinner } from "../ui/statuses"

export const LoadingLayout = () => {
  return (
    <div className="flex h-1/2 items-center justify-center">
      <Spinner size="lg" />
    </div>
  )
}
